module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_mail-d44d4ac45f38c379af66ab4093759e8b.svg";